import { put } from "redux-saga/effects";
import importer from "common/importer";
/* ACTIONS */
const UserActions = importer("Stores/Users/Actions");
const AppointmentsActions = importer("Stores/Appointments/Actions");
const DonorsActions = importer("Stores/Donors/Actions");
const CentersActions = importer("Stores/Centers/Actions");
const PaymenstActions = importer("Stores/Payments/Actions");
const WirecardActions = importer("Stores/Wirecard/Actions");
const LoyaltyActions = importer("Stores/Loyalty/Actions");
/* ENDPOINT */
const { loginFlow } = importer("APIs/auth", null);
const { getMigrationStatus } = importer("APIs/users", null);

export default function* main({ username, password }) {
  try {
    yield cleanState();
    yield put(UserActions.loginLoading());
    const isEmployee = username.includes("@takeda.com");
    let isMigrated = false;
    if (!isEmployee) {
      const checkResponse = yield getMigrationStatus(username, password);
      isMigrated = checkResponse.data.isMigrated;
    }
    if (isMigrated || isEmployee) {
      const oktaLogin = yield loginFlow.loginCallOne(username, password);
      if (oktaLogin.status === 200 && oktaLogin.data) {
        yield put(UserActions.loginSuccess(oktaLogin.data));
      } else {
        throw Error(oktaLogin);
      }
    } else {
      const error = {
        response: { data: { code: "DonorNotMigrated" } },
      };
      yield put(UserActions.loginFailure(error));
    }
  } catch (error) {
    yield put(UserActions.loginFailure(error));
  }
}

function* cleanState() {
  yield put(AppointmentsActions.cleanAppointmentState());
  yield put(DonorsActions.cleanDonorsState());
  yield put(CentersActions.cleanCentersState());
  yield put(PaymenstActions.cleanPaymentState());
  yield put(WirecardActions.cleanWirecardState());
  yield put(LoyaltyActions.cleanLoyaltyDetailsState());
}
